const MATERIAL_TYPE_WORDS = /(^|\s)(?:체크업북|워크북)(?=\s|$)/g

/** 교재 원본 제목은 유지하고 학습자 안내에서만 중복된 교재 종류를 생략한다. */
export function learnerBookTitle(title: string): string {
  return title.replace(MATERIAL_TYPE_WORDS, '$1').replace(/\s+/g, ' ').trim() || title
}
